import React from "react";

import globalReducer from "state";
import { Amplify } from "aws-amplify";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import App from "./App";
import awsmobile from "./aws-exports";

import "./index.css";
import "./index.css";

// import { api } from "state/api";

if(process.env.NODE_ENV !== 'development'){
  console.log = function () {}
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsmobile.aws_user_pools_id,
      userPoolClientId: awsmobile.aws_user_pools_web_client_id,
      identityPoolId: awsmobile.aws_cognito_identity_pool_id,
      loginWith: { email: true },
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_ARTIFACTS_BUCKET,
      region: process.env.REACT_APP_REGION,
    },
  },
  API: {
    REST: {
      gtfsRestApi: {
        endpoint: awsmobile.aws_cloud_logic_custom[0].endpoint,
        region: awsmobile.aws_cloud_logic_custom[0].region,
      },
    },
  },
});

const store = configureStore({
  reducer: {
    global: globalReducer,
    // [api.reducerPath]: api.reducer,
  },
  middleware: (getDefault) => getDefault(),
});
setupListeners(store.dispatch);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // StrictMode is making double call to useEffect, make sure to add in production the issue only happens in development
  // Change React.Fragment to React.StrictMode in production
  <React.Fragment>
    <Provider store={store}>
      <App />
    </Provider>
  </React.Fragment>
);
